import React from 'react';
import {ListItemButton, ListItemIcon, ListItemText} from '@mui/material';

/**
 * A styled list item button component with an icon, primary text, and optional secondary text.
 *
 * @component
 * @param {Object} props - The component properties.
 * @param {string} props.itemPrimaryText - The primary text to be displayed.
 * @param {string} props.itemSecondaryText - The optional secondary text to be displayed.
 * @param {ReactNode} props.itemIcon - The icon to be displayed.
 * @param {Object} props.rest - Additional props for the ListItemButton component.
 * @returns {JSX.Element} The StyledListItemButton component.
 */
const StyledListItemButton = props => {
  const {itemPrimaryText, itemSecondaryText, itemIcon, ...rest} = props;
  return (
    <ListItemButton {...rest}>
      <ListItemIcon>{itemIcon}</ListItemIcon>
      <ListItemText primary={itemPrimaryText} secondary={itemSecondaryText} />
    </ListItemButton>
  );
};

export default StyledListItemButton;
